import { useEffect, useState } from 'react';

import apiFetch, { handleApiFetchError } from '@scale/frontend-lib/api-fetch';
import { IProjectJson } from '@scale/shared/types/project';
import { useRemoAdminCtx } from 'react-scale/components/remoAdmin/remoAdminContext';

export default function useProject(projectId: string | undefined): [IProjectJson | null] {
  const [project, setProject] = useState<IProjectJson | null>(null);
  const remoAdminCtx = useRemoAdminCtx();
  const projectFetchURL = remoAdminCtx.isRemoAdmin ? 'internal/remo-admin' : 'corp-api';

  // Fetch the project based on query parameter.
  useEffect(() => {
    if (!projectId) return;

    setProject(null);

    const signal = { aborted: false };

    apiFetch<IProjectJson>(null, `${projectFetchURL}/projects/${projectId}`)
      .then(project => {
        if (signal.aborted) {
          return;
        }
        setProject(project);
        return;
      })
      .catch(handleApiFetchError);

    return () => {
      signal.aborted = true;
    };
  }, [projectId]);

  return [project];
}
